import { data } from "jquery";
import requests from "./Ajax";

// 获取result页面表格
export const reqResultInfo = (project, subtype, type) =>
  requests({
    url: `/model/show?project=${project}&subtype=${subtype}&type=${type}`,
    method: "get",
  });

export const reqCottonResInfo = (sample, subtype, filetype) =>
  requests({
    url: `/model/showcotton?sample=${sample}&subtype=${subtype}&filetype=${filetype}`,
    method: "get",
  });

export const reqFileNameInfo = (obj) =>
  requests({
    url: `/model/filename?project=${obj.project}&subtype=${obj.subtype}&sample=${obj.sample}&page=${obj.page}&limit=${obj.limit}`,
  });

// 提交序列作业接口
export const reqSubmitSeq = (taskBody) =>
  requests({ url: `model/submit/custom`, method: "post", data: taskBody });

// 提交文件作业接口
export const reqSubmitFlie = (taskBody) =>
  requests({
    url: `/model/submit/file`,
    method: "post",
    data: taskBody,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

// 提交Go模块文件接口
export const resSubmitGoFile = (taskBody) =>
  requests({
    url: `/model/rsubmit/file`,
    method: "post",
    data: taskBody,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

// 提交GO模块数据接口
export const resSubmitData = (form) =>
  requests({
    url: "/model/rsubmit/custom",
    method: "post",
    data: form,
  });

// 提交Blast模块数据接口
export const resSubmitBlastData = (form) =>
  requests({
    url: "/model/blast/custom",
    method: "post",
    data: form,
  });

// 提交Blast文件数据接口
export const resSubmitBlastFile = (taskBody) =>
  requests({
    url: `/model/bsubmit/file `,
    method: "post",
    data: taskBody,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

// 下载Blast文件接口
export const reqBlastTxT = (id) =>
  requests({
    url: `/model/download`,
    method: "get",
    params: {
      taskId: id
    }
  });

export const reqPDFImg = (params) =>
  requests({
    url: `/model/downloadPDF`,
    method: "get",
    params: params
  });

export const reqTasksInfo = () =>
  requests({ url: `/model/status`, method: "get" });

export const reqTaskResultInfo = (params) =>
  requests({ url: `/model/result/predict`, method: "get", params: params });

export const reqCaptchaImg = () =>
  requests({ url: `/model/captcha`, method: "get" });

export const reqVisImg = (taskID, seqID) =>
  requests({
    url: `/model/result/saliency`,
    method: "get",
    params: { taskID, seqID },
  });

export const reqMaizeHot = (taskBody) =>
  requests({ url: `/model/heat`, method: "post", data: taskBody });

// 获取grandient页面和heatmap页面图片
export const reqResGrandientImg = (project, subtype, type) =>
  requests({
    url: `/model/grandient`,
    method: "get",
    params: {
      project,
      subtype,
      type,
    },
  });

// 获取validation页面图片
export const reqResValidationImg = (project, type) =>
  requests({
    url: `/model/validataion`,
    method: "get",
    params: {
      project,
      type,
    },
  });

// 获取Motifs页面图片
export const reqResMotifsImg = (project, subtype, sample) =>
  requests({
    url: `/model/enrichment`,
    method: "get",
    params: {
      project,
      subtype,
      sample,
    },
  });


export const reqAllSubmitData = (taskBody) =>
  requests({
    url: "/model/allsubmit",
    method: "post",
    data: taskBody,
  });

export const reqGenomeInfo = (id) =>
  requests({
    url: `/model/downloadgo`,
    method: "get",
    params: {
      taskId: id,
    },
  });